﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251222
*/
'use strict';
import { bindSelect } from './ctssHtml.js';
import { getPromise } from './ctssJQuery.js';
import { getAppToken } from './snSite.js';

const token = getAppToken();

const getMemberDataAsync = async (params) => {

    let qry = ""
    if (params !== undefined && params.id !== undefined) {
        qry = `?memberId=${params.id}`;
    } else if (params !== undefined && params.mg !== undefined) {
        qry = `?mg=${params.mg}`;
    }

    return await getPromise({ url: `Members/Member${qry}` });
}

const getMemberImgsBaseURLAsync = async () =>
    await getPromise({ url: 'Members/ImgsBaseURL' });

const getMemberProfileAsync = async (params) =>
    await getPromise({ url: `MemberProfile/${token.CG}/${params.mg}` });

const getMemberSearchDataAsync = async () =>
    await getPromise({ url: `Members/${token.CG}/SearchData` });

const getMembersDDLAsync = async () => {

    const listItems =
        await getPromise({ url: `Members/${token.CG}/DDL` });

    bindSelect({ id: 'ddlMembers', items: listItems });

    return listItems;
}
const getMembersDataAsync = async () =>
    await getPromise({ url: `Members/${token.CG}` });

export {
    getMemberDataAsync,
    getMemberImgsBaseURLAsync,
    getMemberProfileAsync,
    getMemberSearchDataAsync,
    getMembersDDLAsync,
    getMembersDataAsync
}
